export const identifyStatus = {
  '0': {
    textColor: '#352FD1', // 左边文字颜色
    leftIcon: 'ing', // 左边ico class
    leftText: '审核中', // 左边文字
    leftDesc: '', // 左边描述
    rightBtn: false, // 是否有按钮
    rightIcon: '', // 右边按钮ico
    rightText: '', // 右边按钮文字
    rightUrl: '' // 右边按钮跳转url
  },
  '3': {
    textColor: '#39D3EA',
    leftIcon: 'no',
    leftText: '已解绑',
    leftDesc: '',
    rightBtn: false, // true,
    rightIcon: '', // require('@/assets/icon/icon_rebind.png'),
    rightText: '', // '重新绑定',
    rightUrl: '' // 'Rebind'
  },
  '2': {
    textColor: '#F16E6F',
    leftIcon: 'failed',
    leftText: '认证失败',
    leftDesc: '',
    rightBtn: false,
    rightIcon: '',
    rightText: '',
    rightUrl: ''
  },
  '1': {
    textColor: '#7DD164',
    leftIcon: 'success',
    leftText: '认证成功',
    leftDesc: '',
    rightBtn: true,
    rightIcon: require('@/assets/icon/icon_unbound.png'),
    rightText: '去解绑',
    rightUrl: 'Unbound'
  }
}



// WEBPACK FOOTER //
// ./src/views/user/config.js